/// <reference path="_references.ts"/>

module App.Chat {
	type fnUnread = (total: number, users: number[]) => void;

	export class ChatService {
		private unreadListeners: fnUnread[] = [];
		private totalUnread: number;
		private curUnread: number[] = [];
		private init: boolean = false;

		constructor(
			private $wamp: $wamp,
			protected $q: ng.IQService,
			protected $timeout: ng.ITimeoutService,
			public $http: ng.IHttpService,
			public Constants: IConstants
		) {
			$timeout(() => {
				this.$wamp.open();

				this.$wamp.subscribe('app.unread', (args: any) => {
					this.init = true;
					this.totalUnread = args[0].count;
					this.curUnread = args[0].users;
					this.unreadListeners.forEach(fn => fn(this.totalUnread, this.curUnread));
				});
			}, 0);
		}

		public subscribeToUnread(fn: fnUnread): void {
			this.unreadListeners.push(fn);
			if (this.init) {
				fn(this.totalUnread, this.curUnread);
			}
		}

		public unsubscribeFromUnread(fn: fnUnread): void {
			let index: number;
			while((index = this.unreadListeners.indexOf(fn)) >= 0) {
				this.unreadListeners.splice(index, 1);
			}
		}

		public subscribeToChat(
			userId: number,
			fnReceive: (m: Message[]) => void
		): ng.IPromise<Subscription> {
			return this.$wamp
				.subscribe('app.chat.' + userId, fnReceive);
		}

		public unsubscribeFromChat(
			sub: Subscription
		): ng.IPromise<void> {
			if (!this.$wamp) {
				return this.$q.when();
			}

			return this.$wamp.unsubscribe(sub);
		}

		public getUsers(): ng.IPromise<ChatUser[]> {
			return this.$wamp.call('app.users')
				.then(r => [...r.args]);
		}

		public sendMessage(
			message: string,
			userId: number
		): ng.IPromise<void> {
			return this.$wamp.publish('app.chat', [{
				message: message,
				recipient: userId
			}], null, {
				acknowledge: true
			});
		}

		public markRead(
			userId: number
		): ng.IPromise<void> {
			return this.$wamp.call('app.read', [userId, ''])
				.then(() => {});
		}

		public getMessages(
			userId: number,
			lastRetrieved: string
		): ng.IPromise<Message[]> {
			return this.$wamp.call('app.messages', [userId, lastRetrieved])
				.then(r => r && r.args || []);
		}

		public getOldMessages(
			userId: number,
			date: string
		): ng.IPromise<Message[]> {
			return this.$wamp.call('app.messages.before', [userId, date])
				.then(r => r && r.args || []);
		}
	}
}